import React from 'react';
import { Alert, Button } from 'antd';
import { useSettings } from '../context/SettingsContext';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';

const TrialBanner = () => {
    const { settings, loading } = useSettings();
    const { user } = useAuth();
    const navigate = useNavigate();
    const { t } = useTranslation();

    if (loading || !settings) return null;

    // Hide for Dev/Super Admin
    if (user && (user.role === 'developer' || user.role === 'super_admin')) {
        return null;
    }

    if (settings.license_type !== 'TRIAL') return null;

    const trialEnd = settings.trial_end_date ? new Date(settings.trial_end_date) : null;
    if (!trialEnd) return null;

    const now = new Date();
    // Calculate days left, robustly
    const diffTime = trialEnd - now;
    const daysLeft = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    // Use dynamic limits from settings
    let message = `${daysLeft} days remaining. Limits: ${settings.max_classes} Classes, 1 Principal, ${settings.max_teachers} Teachers.`;
    let type = 'info';

    if (daysLeft <= 3) {
        type = 'warning';
    }
    if (daysLeft <= 0) {
        message = 'Trial Expired. Please upgrade to continue. Access may be restricted.';
        type = 'error';
    }

    return (
        <Alert
            message={message}
            type={type}
            banner
            style={{ marginBottom: 0, textAlign: 'center' }}
            action={
                <Button size="small" type="primary" onClick={() => navigate('/settings/license')}>
                    {t('license.activate')}
                </Button>
            }
        />
    );
};

export default TrialBanner;
